export const LANDING_ROUTE = "/l";
export const SCREENER_ROUTE = "/s";
export const PROFILING_ROUTE = "/p";
export const START_ROUTE = "/st";
export const SUCCESS_ROUTE = "/su";
export const ENDING_ROUTE = "/e";
export const ERROR_ROUTE = "/err";
export const TERMINATE = "/t";
export const OVER_QUOTA = "/oq";
export const SECURITY_TERMINATE = "/ste";
export const CAMPAIGN_ROUTE = "/c";

// New wow-factor ending pages (token + API driven) — kept on separate paths
// so the existing /su, /t, /oq, /ste pages and components stay untouched.
export const SUCCESS_ROUTE_V2 = "/su2";
export const TERMINATE_V2 = "/t2";
export const OVER_QUOTA_V2 = "/oq2";
export const SECURITY_TERMINATE_V2 = "/ste2";
